import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders }  from "../../utils/axios";

export const reqToGetAllBankList = createAsyncThunk("auth/reqToGetAllBankList",async ({ rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/banks/all`);
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const reqToGetBranchList = createAsyncThunk("auth/reqToGetBranchList",async (data, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/banks/branches/${data?.selectedBankId}`);
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const reqToGetCityList = createAsyncThunk("auth/reqToGetCityList",async (data, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/locations/cities/${data?.selectedStateId}`);
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const reqToGetStateList = createAsyncThunk("auth/reqToGetStateList",async ({ rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/locations/states`);
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const registerUser = createAsyncThunk("auth/registerUser",async (data, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/api/auth/register`, data);
      return response; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const loginUser = createAsyncThunk("auth/loginUser",async (data, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/api/auth/bank/login`, data);
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

// export const logOut = createAsyncThunk(
//   'auth/logOutUser',
//   async (payload, { rejectWithValue }) => {
//     try {
//       const response = await logOutApi(payload);
//       return response;  // Success case
//     } catch (error) {
//       return rejectWithValue(error.response.data);  // Error case
//     }
//   }
// );

export const fetchUserDetails = createAsyncThunk('auth/fetchUserDetails',async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/auth/me`,authHeaders());
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong'); // Error case
    }
  }
);

export const propertyTypesDropdown = createAsyncThunk("properties/propertyTypesDropdown",async ({ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/bank/properties/dropdowns`,authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    banksList: [],
    branchList: [],
    city: [],
    state: [],
    propertyDropdown:[],
  },
  reducers: {},
  extraReducers: (builder) => {
    // request to get all bank list
    builder
      .addCase(reqToGetAllBankList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banksList = action.payload;
      })

      // request to get branch list based on selected bank
      .addCase(reqToGetBranchList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.branchList = action.payload;
      })

      // request to get all city list
      .addCase(reqToGetCityList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.city = action.payload;
      })

      // request to fetch all state list
      .addCase(reqToGetStateList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.state = action.payload;
      })

      // Register a new User
      .addCase(registerUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Login a User through Email and Password
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
        localStorage.setItem("auth-token", JSON.stringify(action.payload));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

        // Fetch User Details
      .addCase(fetchUserDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.user = null;
        state.error = action.payload;
      })

      // Types of property dropdown in (Add Property Form)
       .addCase(propertyTypesDropdown.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDropdown = action.payload;
      })

    // .addCase(logOut.pending, (state) => {
    //   state.isLoading = true;
    //   state.error = null;
    // })
    // .addCase(logOut.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.error = action.payload;
    // })
    // .addCase(logOut.fulfilled, (state, action) => {
    //   state.isAuthenticated = false;
    //   state.user = null;
    // })

   
  },
});

// export const { logout } = authSlice.actions;
export default authSlice.reducer;
